import React from 'react'

interface ProgressIndicatorProps {
  currentSection: number
  sectionName: string
  progress: number
  onShowTips: () => void
}

export function ProgressIndicator({ progress }: ProgressIndicatorProps) {
  return (
    <div className="h-2 bg-muted rounded-full overflow-hidden">
      <div 
        className="h-full bg-primary transition-all duration-300"
        style={{ width: `${progress * 100}%` }}
      />
    </div>
  )
}